export default "__VITE_ASSET__f4c4c9e2__"